<template>
    <dd-modal
      :visible="visible"
      :show-cancel="true"
      @cancel="$emit('cancel')"
      width="52vw"
    >
        <dd-header-card header="E-mail opstellen" style="overflow: unset">
            <h3 class="text-center">Zoek een klant:</h3>
            <DetailedCustomerSelectComponent
                @input="handleCustomerSelect"
            />
          <div class="flex-row justify-content-end align-items-center mt-md">
            <dd-button
              :disabled="!selectedCustomer"
              @click="$emit('input', selectedCustomer)"
            >
              Verder
            </dd-button>
          </div>
        </dd-header-card>
    </dd-modal>
</template>

<script>
import DetailedCustomerSelectComponent from "~/pages/components/customer/DetailedCustomerSelectComponent.vue";

export default {
    name: "CreateModal.vue",
    components:{DetailedCustomerSelectComponent},
    props:{
      visible:{
        type: Boolean
      }
    },
  data(){
      return {
        selectedCustomer: undefined
      }
  },
  methods:{
    handleCustomerSelect(selected){
      this.selectedCustomer = selected;
    }
  },
  watch:{
    visible(){
      if (this.visible){
        this.$nextTick(() => document.querySelector('#detailed-customer-search-input input')?.focus());
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
